import { showNotification } from "@mantine/notifications";
import Papa from "papaparse";
import * as XLSX from "xlsx";

const handleFileUploadCsv = async (file) => {
    // const file = event.target.files[0];

    return new Promise((resolve, reject) => {
        Papa.parse(file, {
            header: true,
            dynamicTyping: true,
            complete: (result) => {
                resolve(result.data);
            },
            error: (error) => {
                reject("CSV Parsing Error: " + error.message);
            },
        });
    });
};

const readFile = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary" });

            workbook.SheetNames.forEach((sheetName) => {
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: null });
                resolve(jsonData);
            });
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsBinaryString(file);
    });
};

const handleFileUploadExcel = async (file) => {
    

    try {
        const jsonData = await readFile(file);
        return jsonData;
    } catch (error) {
        throw Error(error);
    }
};

const excelToCsvData = (temp) => {
    const header = Object.keys(temp[0]);
    const csv = [header.join(", ")];

    for (const row of temp) {
        const values = header.map((key) => row[key]);
        csv.push(values.join(", "));
    }

    const csvData = csv.join("\n");
    return csvData;
}

export const handleChangeUpload = async ({ file }) => {
    const fileText = await file.text();
    // Split lines and remove empty trailing lines
    const lines = fileText.split(/\r?\n/).filter(line => line.trim() !== "");
    
    // Find Header Row flexibly
    const headerIndex = lines.findIndex(line => {
        const cleanLine = line.toLowerCase().replace(/\s/g, "");
        return cleanLine.includes("typeofagreement");
    });

    if (headerIndex === -1) {
        showNotification({ 
            title: "Format Error", 
            message: "Could not find the header row. Please do not delete the column headers.", 
            color: "red" 
        });
        throw Error("Invalid Header");
    }

    const headers = lines[headerIndex].split(",").map(h => h.trim());
    const normalizeHeader = (header) => header.toLowerCase().replace(/\s/g, "");
    const headerLookup = headers.reduce((acc, header) => {
        acc[normalizeHeader(header)] = header;
        return acc;
    }, {});
    const dataRows = lines.slice(headerIndex + 1);
    
    const errors = [];
    const csvDataPreview = [];

    dataRows.forEach((line, index) => {
        // Handle quoted values containing commas (Address, etc)
        const values = line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(v => v.replace(/^"|"$/g, '').trim());
        const rowObj = {};
        headers.forEach((h, i) => rowObj[h] = values[i] || "");

        const endDateHeader = headerLookup["contractenddate"];
        const yearsHeader = headerLookup["noofyears"];
        const monthsHeader = headerLookup["noofmonths"];

        const endDateValue = endDateHeader ? rowObj[endDateHeader] : "";
        const yearsValue = yearsHeader ? parseInt(rowObj[yearsHeader] || 0, 10) : 0;
        const monthsValue = monthsHeader ? parseInt(rowObj[monthsHeader] || 0, 10) : 0;

        const hasDuration = yearsValue > 0 || monthsValue > 0;
        const hasEndDate = endDateValue && endDateValue.toString().trim() !== "";

        // VALIDATION
        headers.forEach(h => {
            const cleanHeader = h.toLowerCase().replace(/\s/g, "");
            
            // SKIP NON-MANDATORY
            if (
                cleanHeader === "secondpartybrandname" ||
                cleanHeader === "location" ||
                cleanHeader === "noofyears" ||
                cleanHeader === "noofmonths" ||
                cleanHeader === "contractenddate"
            ) {
                return;
            }
            
            // CHECK MANDATORY
            if (!rowObj[h] || rowObj[h].toString().trim() === "") {
                errors.push(`Row ${index + headerIndex + 2}: '${h}' is required.`);
            }
        });
        if (!hasEndDate && !hasDuration) {
            errors.push(
                `Row ${index + headerIndex + 2}: 'Contract End Date' or duration (No Of Years/No Of Months) is required.`
            );
        }

        csvDataPreview.push(rowObj);
    });

    if (errors.length > 0) {
        showNotification({
            title: "Validation Error",
            message: errors[0], // Show the specific row and field missing
            color: "red",
        });
        throw Error("Validation failed");
    }

    return [csvDataPreview, null];
};